// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3eBCX{border-color:#e0e8f2;border-radius:16.67%;border-style:dashed;margin:0 auto;overflow:hidden}._208v_{border-radius:50%}._2REX5{margin:0 auto;position:relative}._3gi8e{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;cursor:pointer;font-size:14px;font-size:1.4rem;justify-content:center;line-height:1.5;padding:20px;text-align:center}._35JBx{margin:2.4rem auto 0}", ""]);
// Exports
exports.locals = {
	"container": "_3eBCX",
	"container--round": "_208v_",
	"cropContainer": "_2REX5",
	"uploadBox": "_3gi8e",
	"sliderContainer": "_35JBx"
};
module.exports = exports;
